import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

export const GoogleTagManager = () => {
    const isGTMInitializedRef = useRef(false);
    const gtmId = import.meta.env.VITE_GTM_ID;
    const isProduction = import.meta.env.MODE === "production";
    const isStaging = import.meta.env.MODE === "staging";

    const shouldLoadGTM = (isProduction || isStaging) && gtmId && gtmId !== "GTM-XXXXXXX";

    useEffect(() => {
        if (shouldLoadGTM && !isGTMInitializedRef.current) {
            // Inject noscript iframe in body (Helmet can't do body)
            const noscript = document.createElement("noscript");
            const iframe = document.createElement("iframe");
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.display = "none";
            iframe.style.visibility = "hidden";
            iframe.setAttribute("data-gtm", "true");
            noscript.appendChild(iframe);
            if (document.body) {
                document.body.insertBefore(noscript, document.body.firstChild);
            }

            isGTMInitializedRef.current = true;
        }

        return () => {
            if (shouldLoadGTM) {
                // Only remove the noscript iframe we created
                const iframes = document.querySelectorAll('iframe[data-gtm="true"]');
                iframes.forEach((iframe) => {
                    iframe.parentElement?.remove(); // Remove noscript wrapper
                });

                isGTMInitializedRef.current = false;
            }
        };
    }, [shouldLoadGTM, gtmId]);

    if (!shouldLoadGTM) {
        return null;
    }

    return (
        <Helmet>
            <script>
                {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`}
            </script>
        </Helmet>
    );
};

